import {Application} from "../lib/Application.js";

export const app = new Application();